const Shared = {
    socket: undefined,
    tools: undefined,
    contentTypes: undefined,
};

export default Shared;